import { useState, useEffect, useRef } from 'react'
import Navbar from './Navbar';
import ModuleList from './moduleList';
import ButtonBox from '../../Common/ButtonBox';
import { useNavigation } from '../../../Contexts/navigationContext';
import downVector from "../../../img/down-vector.svg";


const tags = ["DSA", "System Design","Full Stack Development","Backend in Springboot", "Agentic AI"];
export const dsaModules = [
    {
        "module": "Module 1",
        "startingModule": true,
        "title": "Begin with Programming",
        "description": "Introduction, Datatypes, Input Output, Operators, Decision Making, Loops, Arrays, Strings, Pointers, Functions, Structures",
        "videoCount": 10,
        "topics": [
            { "question": "1: What is Programming?", "preview": true, src: "https://storage.googleapis.com/course_curriculums/Integer%20Overflows.mp4" },
            { "question": "2: Fundamental Datatypes", "preview": true, src: "https://storage.googleapis.com/course_curriculums/Nested%20While%20Loops.mp4" },
            { "question": "3: Printing Output", "preview": true, src: "https://storage.googleapis.com/course_curriculums/Intro%20to%20Pointer%20Arithmetic.mp4" },
            { "question": "4: Basic Arithmetic Operators", "preview": false },
            { "question": "5: Introduction to Decision Making", "preview": false }
        ]
    },
    {
        "module": "Module 2",
        "startingModule": false,
        "title": "Gearing Up",
        "description": "Arrays, Maths, Time and Space Complexity, Recursion and Backtracking",
        "videoCount": 10,
        "topics": [
            { "question": "1: Pre-computation Techniques", "preview": true, src: "https://storage.googleapis.com/course_curriculums/Maximum%20Chunks.mp4" },
            { "question": "2: Greatest Common Divisor", "preview": true, src: "https://storage.googleapis.com/course_curriculums/Recursion%20Tree%20Diagram.mp4" },
            { "question": "3: Introducing Time Complexity", "preview": true, src: "https://storage.googleapis.com/course_curriculums/Recursion%20Stack%20Diagram.mp4" },
            { "question": "4: Basics of Recursion", "preview": false },
            { "question": "5: Permutations of a String - 1", "preview": false }
        ]
    },
    {
        "module": "Module 3",
        "startingModule": false,
        "title": "Fundamental Algorithms",
        "description": "Searching, Sorting Algorithms, Two Pointers, Bit Manipulation",
        "videoCount": 10,
        "topics": [
            { "question": "1: Binary Search", "preview": true, src: "https://storage.googleapis.com/course_curriculums/K-th%20Smallest%20in%20Array-1.mp4" },
            { "question": "2: Comparators and Stability", "preview": true, src: "https://storage.googleapis.com/course_curriculums/K-th%20Smallest%20in%20Array-2.mp4" },
            { "question": "3: Pair Sum-1", "preview": true, src: "https://storage.googleapis.com/course_curriculums/K-th%20Smallest%20in%20Matrix.mp4" },
            { "question": "4: Bitwise Operators-1", "preview": true, src: "https://storage.googleapis.com/course_curriculums/Inversion%20Count.mp4" },
            { "question": "5: Bitwise Operators-2", "preview": false }
        ]
    },
    {
        "module": "Module 4",
        "title": "Fundamental Data Structures",
        "description": "Hashing, Stacks, Queues, Linked Lists and Trees",
        "videoCount": 10,
        "topics": [
            { "question": "1: What is Hashing?", "preview": true, src: "https://storage.googleapis.com/course_curriculums/Next%20Greater%20Element.mp4" },
            { "question": "2: What is a Stack?", "preview": true, src: "https://storage.googleapis.com/course_curriculums/Largest%20Area%20Rectangle.mp4" },
            { "question": "3: What is a Queue?", "preview": true, src: "https://storage.googleapis.com/course_curriculums/Binary%20Matrix%20-%201.mp4" },
            { "question": "4: What is a Linked List?", "preview": true, src: "https://storage.googleapis.com/course_curriculums/Binary%20Matrix%20-%202.mp4" },
            { "question": "5: What are Trees?", "preview": false }
        ]
    },
    {
        "module": "Module 5",
        "title": "Advanced DSA - 1",
        "description": "Range Queries, Tries, Graph Algorithms",
        "videoCount": 10,
        "topics": [
            { "question": "1: Intro to Range Queries", "preview": true, src: "https://storage.googleapis.com/course_curriculums/Breadth%20First%20Search.mp4" },
            { "question": "2: Prefix Match Problem", "preview": true, src: "https://storage.googleapis.com/course_curriculums/BFS%20Tree.mp4" },
            { "question": "3: Introduction to Tries", "preview": true, src: "https://storage.googleapis.com/course_curriculums/Shortest%20Path%20in%20an%20Undirected%20Graph.mp4" },
            { "question": "4: What is a Graph?", "preview": false },
            { "question": "5: Important Terms for Graph", "preview": false }
        ]
    },
    {
        "module": "Module 6",
        "title": "Advanced DSA - 2",
        "description": "Heaps, Greedy, Dynamic Programming",
        "videoCount": 10,
        "topics": [
            { "question": "1: What is Heap?", "preview": true, src: "https://storage.googleapis.com/course_curriculums/Count%20of%20Decodings-1.mp4" },
            { "question": "2: Building a Max Heap - 1", "preview": true, src: "https://storage.googleapis.com/course_curriculums/Pattern%20Matching-1.mp4" },
            { "question": "3: What is Greedy Algorithm?", "preview": true, src: "https://storage.googleapis.com/course_curriculums/Counting%20Subsequences%20-%201.mp4" },
            { "question": "4: What is DP?", "preview": true, src: "https://storage.googleapis.com/course_curriculums/Matrix%20Chain%20Multiplication%20-%201.mp4" },
            { "question": "5: Top Bottom vs Bottom Top?", "preview": false }
        ]
    },
    {
        "module": "Module 7",
        "title": "CS Fundamentals",
        "description": "Operating Systems, Database Management Systems, Computer Networks",
        "videoCount": 10,
        "topics": [
            { "question": "1: Introduction to OS", "preview": true, src: "https://storage.googleapis.com/course_curriculums/Introduction%20to%20Process%20Scheduling-FIFO.mp4" },
            { "question": "2: Introduction to DBMS", "preview": true, src: "https://storage.googleapis.com/course_curriculums/Shortest%20Job%20First%20Algorithm.mp4" },
            { "question": "3: CRUD Operations using SQL", "preview": true, src: "https://storage.googleapis.com/course_curriculums/Joins%20in%20SQL.mp4" },
            { "question": "4: Introduction to Computer Networks", "preview": false },
            { "question": "5: OSI Model", "preview": false }
        ]
    },
    {
        "module": "Module 8",
        "title": "Intro to Low Level Design",
        "description": "OOPS, Clean Coding Principles, Testability, Design Patterns, Case Studies",
        "videoCount": 10,
        "topics": [
            { "question": "1: What is Clean Coding?", "preview": true, src: "https://storage.googleapis.com/course_curriculums/Design%20Chess.mp4" },
            { "question": "2: Separating out Files", "preview": true, src: "https://storage.googleapis.com/course_curriculums/Strategy%20Pattern.mp4" },
            { "question": "3: Single Responsibility Principle", "preview": true, src: "https://storage.googleapis.com/course_curriculums/Decorator%20Pattern%20-%201.mp4" },
            { "question": "4: Open Closed Principle", "preview": true, src: "https://storage.googleapis.com/course_curriculums/Correct%20placement%20of%20Locks.mp4" },
            { "question": "5: Design Tic-Tac-Toe-1", "preview": false }
        ]
    },
    {
        "module": "Module 9",
        "title": "Low Level Design & Concurrency Pro",
        "description": "Machine Coding, Concurrent Programming Skills, Case Studies",
        "videoCount": 10,
        "topics": [
            { "question": "1: Right Way to Approach Problem", "preview": true, src: "https://storage.googleapis.com/course_curriculums/Intro%20to%20Race%20Conditions.mp4" },
            { "question": "2: Builder Pattern", "preview": true, src: "https://storage.googleapis.com/course_curriculums/Into%20to%20Lock.mp4" },
            { "question": "3: What is Unit Test?", "preview": true, src: "https://storage.googleapis.com/course_curriculums/More%20on%20Locks.mp4" },
            { "question": "4: Concurrency vs. Parallelism", "preview": true, src: "https://storage.googleapis.com/course_curriculums/Correct%20placement%20of%20Locks.mp4" },
            { "question": "5: A Simple Multithreaded Server", "preview": false }
        ]
    },
    {
        "module": "Module 10",
        "title": "High Level Design",
        "description": "SQL vs NoSQl, Distributed DB, CAP, Caching, Message Queue, Linux Systems, Case Studies",
        "videoCount": 10,
        "topics": [
            { "question": "1: Understanding Web Architecture - Frontend", "preview": true, src: "https://storage.googleapis.com/course_curriculums/Functional%20%26%20Non-Functional%20Requirements.mp4" },
            { "question": "2: Database Reliability: Replication", "preview": true, src: "https://storage.googleapis.com/course_curriculums/Capacity%20Estimation.mp4" },
            { "question": "3: Backend Reliability: REST APIs", "preview": true, src: "https://storage.googleapis.com/course_curriculums/Basic%20System%20Design.mp4" },
            { "question": "4: Introduction to Caches", "preview": true, src: "https://storage.googleapis.com/course_curriculums/Maintainability%20of%20Design%20-%20Microservices.mp4" },
            { "question": "5: Tackling System Design Problems", "preview": true, src: "https://storage.googleapis.com/course_curriculums/Process%20vs%20Thread.mp4" }
        ]
    },
    {
        "module": "Module 11",
        "title": "In-depth MERN Stack Development",
        "description": "Introduction, Html Essentials: Structuring The Web, The Basics Of Styling: Getting Started With CSS, Advanced CSS",
        "videoCount": 10,
        "topics": [
            { "question": "1: Introduction to HTML", "preview": true, src: "https://storage.googleapis.com/course_curriculums/Intro%20to%20Flex%20Box.mp4" },
            { "question": "2: Introduction to CSS", "preview": true, src: "https://storage.googleapis.com/course_curriculums/Flex%20Box%20in%20Depth.mp4" },
            { "question": "3: Inheritance in depth with forms", "preview": true, src: "https://storage.googleapis.com/course_curriculums/Flex%20Box%20Practice.mp4" },
            { "question": "4: Flex Box in Depth", "preview": false },
            { "question": "5: Webpage Rendering Process", "preview": false }
        ]
    },
    {
        "module": "Module 12",
        "title": "In-depth Backend Dev in Java Springboot",
        "description": "Master Spring frameworks, JPA, Hibernate, JWT, Spring Security Filters",
        "videoCount": 10,
        "topics": [
            { "question": "1: Dependencies and Maven", "preview": true, src: "https://storage.googleapis.com/course_curriculums/Dependency%20Injectionin%20Spring.mp4" },
            { "question": "2: Spring MVC Introduction", "preview": true, src: "https://storage.googleapis.com/course_curriculums/IoC%20Containers%20and%20Beans%20in%20Spring.mp4" },
            { "question": "3: Introduction to JDBC", "preview": true, src: "https://storage.googleapis.com/course_curriculums/Initializing%20a%20Spring%20Project%20using%20Spring%20Initializer.mp4" },
            { "question": "4: Introduction to Hibernate", "preview": true, src: "https://storage.googleapis.com/course_curriculums/Convention%20over%20Configuration.mp4" },
            { "question": "5: About Spring JPA", "preview": true, src: "https://storage.googleapis.com/course_curriculums/Spring%20Application-%20Internal%20Concepts.mp4" }
        ]
    },
    {
        "module": "Module 13",
        "title": "Agentic AI and LLMs",
        "description": "Learn to build real-world AI systems with LLMs, RAG, tools, evals, and fine-tuning.",
        "videoCount": 10,
        "topics": [
            { "question": "1: Query Inference flow", "preview": true, src:"https://storage.googleapis.com/ppa-prod-landing-pages-media/Renaissance_landing_pages/AI_Engg_Query_inference_flow.mp4"},
            { "question": "2: Sampling of tokens and Post-training", "preview": true, src:"https://storage.googleapis.com/ppa-prod-landing-pages-media/Renaissance_landing_pages/AI_Engg_Sampling_of_tokens_and_post_training.mp4"},
            { "question": "3: Prompt Engineering", "preview": false},
            { "question": "4: API calls, Memory and Tool calling", "preview": false},
            { "question": "5: Oncall Ops Agent", "preview": false}
        ]
    },
]



const Content = () => {
    const [activeTag, setActiveTag] = useState(0);
    const [isSelectedModule, setIsSelectedModule] = useState("Module 1");
    const { scrollToPlans } = useNavigation();
    const moduleRefs = useRef({});
    const scrollContainerRef = useRef(null);

    const tagToModuleMap = {
        0: "Module 1",
        1: "Module 8",
        2: "Module 11",
        3: "Module 12",
        4: "Module 13",
    };

    useEffect(() => {
        const defaultModule = tagToModuleMap[activeTag];
        setIsSelectedModule(defaultModule);
    }, [activeTag]);

    const handleTagChange = (_, index) => {
        setActiveTag(index);
        setIsSelectedModule(tagToModuleMap[index]);
    };

    useEffect(() => {
        const container = scrollContainerRef.current;
        const el = moduleRefs.current[isSelectedModule];
    
        if (el && container) {
            requestAnimationFrame(() => {
                container.scrollTo({
                    top: el.offsetTop - container.offsetTop,
                    behavior: "smooth"
                });
            });
        }
    }, [isSelectedModule]);


    return (
        <div className='flex items-center justify-center'>
            <div className='space-y-10'>
                <Navbar
                    tags={tags}
                    onTagChange={handleTagChange}
                    activeTag={tags[activeTag]}
                />
                <ModuleList
                    setIsSelectedModule={setIsSelectedModule}
                    isSelectedModule={isSelectedModule}
                    moduleRefs={moduleRefs}
                    scrollContainerRef={scrollContainerRef}
                    setActiveTag={setActiveTag}
                />
                <div className='flex justify-center items-center cursor-pointer'>
                    <ButtonBox
                        borderColor=''
                        borderRadius='10px'
                        borderWidth=''
                        backgroundColor='#3940A0'
                        className='py-3 px-12 flex items-center justify-center text-white w-fit'
                        onClick={scrollToPlans}
                    >
                        <div className='flex items-center gap-5'>
                            View Pricing
                            <img src={downVector} alt='Navigate To Pricing' width={12} height={12} />
                        </div>
                    </ButtonBox>
                </div>
            </div>
        </div>
    );
};

export default Content;